import { enableES5 } from 'immer'
enableES5()
import initSentry from 'utils/initSentry'

initSentry({
  dsn: 'https://c1f4eff8df5a4dcd97d44ca700914c82@o95049.ingest.sentry.io/1254882',
  blockExceptions: [
    "Cannot read property 'active' of undefined",
    "Unable to get property 'active' of undefined or null reference",
    'XDR encoding failure',
    "Cannot read properties of undefined (reading 'includes')",
    'ResizeObserver loop completed with undelivered notifications.',
  ],
})

import 'raf/polyfill'
import 'core-js/es/symbol'
import 'core-js/es/object'
import 'core-js/es/function'
import 'core-js/es/parse-int'
import 'core-js/es/parse-float'
import 'core-js/es/number'
import 'core-js/es/math'
import 'core-js/es/string'
import 'core-js/es/date'
import 'core-js/es/array'
import 'core-js/es/regexp'
import 'core-js/es/map'
import 'core-js/es/weak-map'
import 'core-js/es/set'
import 'core-js/features/promise'
import 'components/Translation/i18n.js'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import moment from 'moment'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'

moment.locale(global.defaultLanguage)

import 'bootstrapper'
import 'styles/semantic-ui-global-overwrite.css'
// import "ubold/css/bootstrap.min.css"
// import "semantic-ui-css/semantic.min.css"
// import "ubold/css/style.css"
// import "ubold/css/icons.css"
// import "ubold/css/spinner.css"
// import "react-select/dist/react-select.css"
// import "ubold/css/react-select-upgrades.css"
// import "bootstrap-daterangepicker/daterangepicker.css"
import 'react-toastify/dist/ReactToastify.min.css'
// import "react-datepicker/dist/react-datepicker.css"
import 'react-bootstrap-typeahead/css/Typeahead.css'
import './css/style.css'

global.isGO = getIsGO()

import { SystemContextProvider } from '../1stlog-ui/src/contexts/SystemContext'
import { getIsGO } from '../1stlog-ui/src/utils/getIsGO'
import Root from './containers/Root'
import auftragStore from './store'

const store = auftragStore

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // TODO: enable for prod?
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

const render = (routerKey = null) => {
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <RecoilRoot>
            <SystemContextProvider>
              <Root />
            </SystemContextProvider>
          </RecoilRoot>
        </QueryClientProvider>
      </Provider>
    </BrowserRouter>,
    document.getElementById('root'),
  )
}

render()
